angular.module('mtic.components.dashboards.badbrowser', [])

angular.module('mtic.components.dashboards.badbrowser')
.directive('dashboardBadBrowser', function ($timeout) {
  return {
    templateUrl: 'template.html',
    scope: {},
    link: function (scope) {

      scope.compatibleBrowser = true;
      scope.compatibleDevice = true;

      if(bowser.name !== 'Chrome'){
        scope.compatibleBrowser = false;
      }
      if (bowser.mobile || bowser.tablet){
        scope.compatibleDevice = false;
      }

      scope.closeClicked = () => {
        $timeout( () => {
          scope.hideNag = true;
          $timeout( () => {
            scope.hideNag = false;
          }, 120000);
        });
      }

    }
  }
})
